import { downloadBlob } from 'modules/core/lib/download'

/* disposition param is a string which constains the follow structure:
'attachment; filename="example.xlsx"; filename*=UTF-8''example.xlsx'
and we use regexp to retrieve the filename value
*/
const getFileName = (disposition: string) => {
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
  const matches = filenameRegex.exec(disposition)

  if (matches != null && matches[1]) {
    return matches[1].replace(/['"]/g, '')
  }
}

interface DownloadProps {
  fullPath: string
  filename?: string
}

export async function download({ fullPath, filename }: DownloadProps) {
  const res = await fetch(fullPath, { credentials: 'include' })

  if (!res.ok) {
    throw new Error(`Error fetching ${fullPath}. Status: ${res.status}`)
  }

  const disposition = res.headers.get('content-disposition') ?? ''

  const docFilename = filename || getFileName(disposition)

  if (!docFilename) {
    throw new Error(`Error processing ${fullPath} response. Is expected to contain filename value`)
  }

  const blob = await res.blob()
  downloadBlob(blob, docFilename)
}
